// src/firebaseConfig.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getAnalytics, isSupported as isAnalyticsSupported } from "firebase/analytics";
import { getPerformance } from "firebase/performance";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Singleton pattern: Check if app exists, otherwise initialize
export const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

// 🚀 ENTERPRISE OPTIMIZATION: Enable Local Caching (IndexedDB) with modern v9 API
// For local testing of multiple roles, we disable shared cache on localhost.
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
export const db = initializeFirestore(app, isLocalhost ? {} : {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});

export const auth = getAuth(app);
export const storage = getStorage(app);

// Initialize Analytics & Performance Monitoring conditionally (e.g., only in production or if supported in browser)
export let analytics = null;
isAnalyticsSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
  }
});

export const perf = getPerformance(app);
